import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toaster } from "../components/toaster";
import { OpenAPI } from "../generated";

export const useDuplicateInvoice = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ["duplicateInvoice"],
    mutationFn: async (invoiceUuid: string) => {
      const response = await fetch(
        `${OpenAPI.BASE}/api/invoices/${invoiceUuid}/duplicate/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        },
      );
      if (!response.ok) {
        throw new Error("Duplisering feilet");
      }
      return response.json();
    },
    onSuccess: (data) => {
      toaster.success({ title: "Faktura duplisert!" });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
      navigate(`/invoices/${data.uuid}/`);
    },
    onError: () => {
      toaster.error({ title: "Kunne ikke duplisere faktura" });
    },
  });
};
